import { Component, EventEmitter, OnInit, Input, Output, OnChanges } from '@angular/core';

@Component({
  selector: 'app-monitoring-filters-select-date',
  templateUrl: './monitoring-filters-select-date.component.html',
  styleUrls: ['./monitoring-filters-select-date.component.scss']
})
export class MonitoringFiltersSelectDateComponent {

    @Input() title: string;

    @Input() @Output() date: Date;

    @Output() change = new EventEmitter<Date>();

    constructor () {}

    onChange (date: Date) {
        this.date = date;
        this.change.emit(this.date);
    }
}
